module.exports = __webpack_public_path__ + "static/img/弹窗.2fb6d53.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/market/market109/弹窗.png
// module id = eAfN
// module chunks = 1